import { FC, HTMLAttributes } from 'react'

export const IconImage: FC<HTMLAttributes<HTMLOrSVGElement>> = ({ ...props }) => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path d="M16.2 8.11053C11.643 8.32416 7.93 11.7655 7.2957 16.2H15.3C15.7971 16.2 16.2 15.7971 16.2 15.3V8.11053ZM5.48017 16.2C6.12964 10.7693 10.6479 6.52724 16.2 6.30884V2.7C16.2 2.20294 15.7971 1.8 15.3 1.8H2.7C2.20294 1.8 1.8 2.20294 1.8 2.7V15.3C1.8 15.7971 2.20294 16.2 2.7 16.2H5.48017ZM2.7 0H15.3C16.7912 0 18 1.20883 18 2.7V15.3C18 16.7912 16.7912 18 15.3 18H2.7C1.20883 18 0 16.7912 0 15.3V2.7C0 1.20883 1.20883 0 2.7 0ZM5.4 7.2C4.40589 7.2 3.6 6.39411 3.6 5.4C3.6 4.40589 4.40589 3.6 5.4 3.6C6.39411 3.6 7.2 4.40589 7.2 5.4C7.2 6.39411 6.39411 7.2 5.4 7.2Z" fill="#666666" />
		</svg>
	)
}
